import { FunctionComponent } from "react";
import cx from "clsx";
// import { ChevronRight } from "react-bootstrap-icons";

type BreadCrumbItemProps = {
  label: string;
  className?: string;
  progress: string;
};

export const BreadCrumbItem: FunctionComponent<BreadCrumbItemProps> = (
  props,
) => {
  return (
    <div className="relative flex flex-shrink-0 flex-col items-center gap-y-3">
      <div
        className={cx(
          "grid h-7 w-7 place-items-center rounded-full border border-black text-sm font-semibold",
          props.className,
        )}
      >
        {props.progress}
      </div>
      <div className="absolute -bottom-8 w-32 text-center text-sm md:text-base lg:text-base xl:text-base">
        {props.label}
      </div>
    </div>
  );
};
